// extracted by mini-css-extract-plugin
export var dataCell = "_l4-2";
export var dataRow = "_l4-0";
export var headerRow = "_l4-1";